import React from "react";
import { CareersList } from "../../constants/data/CareersJson";
import OptionItem from "./OptionItem";

export default function OptionList() {

  return (
    <div className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[29px] font-bold text-gray-900 mb-2">
          Open Positions
        </h1>
        <p className="text-lg text-gray-600 mb-10">
          Explore exciting opportunities to grow your career with us
        </p>

        <div className="grid gap-6 md:grid-cols-2">
          {/* grid gap-6 md:grid-cols-2 */}
          {CareersList.map((pos, idx) => (
            <OptionItem pos={pos} idx={idx} key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
}
